import axios from "axios";
import "./App.css";
import { useEffect, useState, useRef } from "react";
import { getFareEstimate } from "./price.js";
import MapPicker from "./map.js";
import FareDetails from "./data.js";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

function App() {
  const mediumTypes = ["Ura Car", "Ura Bike", "Ura Auto", "Ura Premium"];

  const origin = { lat: 25.70548201901631, lng: 94.1064382172731 };
  const destination = { lat: 25.87646967189925, lng: 93.76294513676919 };
  const [price, setPrice] = useState(null);
  const [outStat, setOutStat] = useState("----");

  const [showDestinationPicker, setShowDestinationPicker] = useState(false);

  const [selectedUser, setSelectedUser] = useState(null);

  const GOOGLE_MAPS_API_KEY = "AIzaSyDJWb2g6bYlGDSFG4r7YaF9VxGmBVIRvyk";


  const outsatationId = '83ed0c46-28fc-40ec-a18b-27a5ab1a7665'

  const [users, setUsers] = useState([
    {
      id: "72e2f0d5-b1a7-4e20-a935-bcae7f4eb3df",
      name: "Kaushal",
      role: "user",
      state: "Idle",
      message: "",
      tripData: null,
      medium: "",
    },
    {
      id: "3195f384-7022-4acc-bbda-ea6c95b36c37",
      name: "Lima",
      role: "user",
      state: "Idle",
      message: "",
      tripData: null,
      medium: "",
    },
  ]);

  const MY_URL = "https://mc-ubuntu.tail02c94b.ts.net/api";
  // const MY_URL = "http://192.168.1.2:5000";

  // useEffect(() => {
  //   const y = async () => {
  //     await getFareEstimate(origin, destination, "small").then((fare) => {
  //       console.log(fare);
  //       setPrice(fare);
  //     });
  //   };
  //   y();
  // }, []);

  useEffect(() => {
    users.forEach((u) => {
      fetchMyRideDetails(u.id);
    });
  }, []);

  const fetchMyRideDetails = async (userId) => {
    try {
      const res = await axios.get(`${MY_URL}/user/launch`, {
        headers: {
          "test-key": "abc123",
          "test-user-id": userId,
        },
        timeout: 5000,
      });

      const activeRequest = res.data.activeRequest;

      if (!activeRequest || Object.keys(activeRequest).length === 0) {
        return;
      }

      const [requestId, tripDetails] = Object.entries(activeRequest)[0];

      setUsers((prevUsers) =>
        prevUsers.map((u) =>
          u.id === tripDetails.userId
            ? {
                ...u,
                requestId,
                tripData: tripDetails,
              }
            : u,
        ),
      );
    } catch (err) {
      console.error(err.response?.data || err.message);
    }
  };

  useEffect(() => {
    console.log("Users state updated:", users);
  }, [users]);

  const token = localStorage.getItem("token");

 async function ty(){

  }

  const sendDummyTrip = async () => {
    setOutStat("Sending dummy trip data...");
    try {
      const response = await axios.post(
        `${MY_URL}/requests/user/trip`,
        {
          // user_id: "72e2f0d5-b1a7-4e20-a935-bcae7f4eb3df",
          user_id: outsatationId,
          trip_type: "ONE_WAY",
          departure_date: "2026-04-25 10:30:00",
          origin: "Kohima",
          destination: "Diampur",
          origin_coordinates: { lat: 30.7333, lng: 76.7794 },
          destination_coordinates: { lat: 32.2432, lng: 77.1892 },
          price: 3500.5,
          distance: 280.75,
          payment_type: "CASH",
          service: 2,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      console.log("Status:", response.data);
      const data = response.data;

      console.log("Response:", data);
      setOutStat("Dummy trip data sent successfully.");
    } catch (err) {
      console.log("Error:", err);
      setOutStat("Error sending dummy trip data.");
    } finally {
      setTimeout(() => {
        setOutStat("");
      }, 3000);
    }
  };

  const handleRoute = async (origin, destination) => {
    const fare = await getFareEstimate(origin, destination, "small");

    console.log("Fare:", fare);
    setPrice(fare);
  };

  const tripData = {
    value: {
      pickupAddress: "New secretariate, kohima, Nagaland ",
      pickupLatLng: {
        latitude: 26.29538838935066,
        longitude: 94.50238122548204,
        //  latitude: 25.682185963700885,
        // longitude: 94.1074881829878,
      },
      destinationAddress: "Ungma, Mokukchung, Nagaland ",
      destinationLatLng: {
        latitude: 26.324862566780553,
        longitude: 94.5158519283658,
      },
      distance: 12.5,
      price: 380,
      paymentMode: "card",
      // tripId: "TRIP123456",
      // mediumType: mediumTypes[Math.floor(Math.random() * mediumTypes.length)],
      mediumType: "Ura Car",
      // fcmToken: "dummy_fcm_token_abc123",
    },
  };

  const jsonBody = {
    location: {
      pickup: {
        formattedAddress: tripData.value.pickupAddress ?? null,
        // latitude: tripData.value.pickupLatLng?.latitude ?? null,
        // longitude: tripData.value.pickupLatLng?.longitude ?? null,
        // pickupLatLng: {
        latitude: 25.70494304474174, 
        longitude: 94.1063537418393,
        //  latitude: 25.682185963700885,
        // longitude: 94.1074881829878,
        // }
      },
      destination: {
        formattedAddress: tripData.value.destinationAddress ?? null,
        latitude: tripData.value.destinationLatLng?.latitude ?? null,
        longitude: tripData.value.destinationLatLng?.longitude ?? null,
      },
    },
    distance: tripData.value.distance ?? null,
    price: tripData.value.price ?? null,
    payment_mode: tripData.value.paymentMode ?? null,
    trip_id: tripData.value.tripId ?? null,
    vehicle_type: tripData.value.mediumType ?? null,
    fcmToken: tripData.value.fcmToken ?? null,
  };

  const jsonBody2 = {
    location: {
      pickup: {
        formattedAddress: tripData.value.pickupAddress ?? null,
        // latitude: tripData.value.pickupLatLng?.latitude ?? null,
        // longitude: tripData.value.pickupLatLng?.longitude ?? null,
        // latitude: 25.70492896196128,
        // longitude: 94.10626458884022,
        latitude: 25.704853321858554,
        longitude: 94.10630668662571,
      },
      destination: {
        formattedAddress: tripData.value.destinationAddress ?? null,
        latitude: 25.66898591340687,
        longitude: 94.10581788459412,
        // formattedAddress: tripData.value.destinationAddress ?? null,
        // latitude: tripData.value.destinationLatLng?.latitude ?? null,
        // longitude: tripData.value.destinationLatLng?.longitude ?? null,
      },
    },
    distance: tripData.value.distance ?? null,
    price: tripData.value.price ?? null,
    payment_mode: tripData.value.paymentMode ?? null,
    trip_id: tripData.value.tripId ?? null,
    vehicle_type: tripData.value.mediumType ?? null,
    fcmToken: tripData.value.fcmToken ?? null,
  };

  // const [users, setUsers] = useState([
  //   {
  //     id: "654b9ab0-3b11-4ac1-b54e-b2379e1ca3df",
  //     name: "Kaushal",
  //     role: "User",
  //     state: "Idle",
  //     message: "",
  //     tripData: null,
  //     medium: "",
  //   },
  //   {
  //     id: "3195f384-7022-4acc-bbda-ea6c95b36c37",
  //     name: "Lima",
  //     role: "User",
  //     state: "Idle",
  //     message: "",
  //     tripData: null,
  //     medium: "",
  //   },
  // ]);

  const [accepts, setAccepts] = useState([]);

  const socketsRef = useRef({});

  useEffect(() => {
    users.forEach((user) => connectUser(user));
    fetchAccepted();
  }, []);

  const fetchAccepted = async (req, res) => {
    try {
      await axios
        // .get(`${MY_URL}/requests/user/accept/${users[1].id}`)
        .get(`${MY_URL}/requests/user/accept/${outsatationId}`)
        .then((response) => {
          console.log("popopoddd :", response.data);
          setAccepts(response.data);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const confirmBook = async (item) => {
    try {
      await axios
        .post(`${MY_URL}/requests/user/update-booking`, {
          request_id: item.request_id,
        })
        .then((response) => {
          console.log("popopoddd :", response.data);
          setAccepts((prev) =>
            prev.filter(
              (acceptItem) => acceptItem.request_id !== item.request_id,
            ),
          );
        });
    } catch (e) {
      console.log(e);
    }
  };

  const connectUser = (user) => {
    // const ws = new WebSocket(`ws://192.168.1.101:9095?userId=${user.id}`);
    const ws = new WebSocket(`wss://mc-ubuntu.tail02c94b.ts.net/ws?userId=${user.id}`);

    ws.onopen = () => {
      console.log(`${user.name} connected`);
      ws.send(
        JSON.stringify({
          type: "init",
          userId: user.id,
        }),
      );
    };

    ws.onmessage = (e) => {
      const parsed = JSON.parse(e.data);

      ws.send(
        JSON.stringify({
          type: "clientAck",
          userId: user.id,
          messageId: parsed.messageId,
        }),
      );

      setUsers((prevUsers) =>
        prevUsers.map((u) => {
          if (u.id !== user.id) return u;

          if (parsed.type === "noCabs") {
            return {
              ...u,
              state: "Idle",
              message: parsed.message.reason,
            };
          }

          if (parsed.type === "driverFound") {
            // console.log("Driver Found Data:", parsed);

            // getTripDetails(user.id)
            return {
              ...u,
              message: `Cab Found: ${parsed.driver_data.driver_name}`,
            };
          }

          if (parsed.type === "ride_status") {
            const action = parsed.userRideStatus.action;
            console.log("Ride Status Update:", parsed);
            if (action === "Completed") {
              console.log("completed");
            } else {
              getTripDetails(
                parsed.userRideStatus.trip_id,
                parsed.connection.userId,
              );
            }

            if (action === "Completed") {
              return {
                ...u,
                tripData: null,
                // message: "Completed",
              };
            }
            // else if(){
            //   return {
            //     ...u,
            //     tripData: null,
            //     // message: "Completed",
            //   };
            // }

            return {
              ...u,
              tripData: parsed.userRideStatus,
              // message: action,
            };
          }

          return u;
        }),
      );
    };

    ws.onclose = () => {
      console.log(`${user.name} disconnected`);
    };

    socketsRef.current[user.id] = ws;
  };

  const handleSearch = async (id) => {
    setUsers(
      users.map((u) => (u.id === id ? { ...u, state: "Searching" } : u)),
    );
    let data;
    try {
      const currentUser = users.find((u) => u.id === id);
      if (id == "72e2f0d5-b1a7-4e20-a935-bcae7f4eb3df") {
        data = {
          ...jsonBody,
          vehicle_type: currentUser?.medium,
        };
      } else {
        data = {
          ...jsonBody2,
          vehicle_type: currentUser?.medium,
        };
      }
      console.log("data b4 sending", data);
      const search = await axios.post(`${MY_URL}/user/findSuitableTaxi`, data, {
        headers: {
          "test-key": "abc123",
          "test-user-id": id,
        },
        timeout: 5000,
      });
      console.log("Search Response:", search.data);
    } catch (err) {
      console.error(err.response?.data || err.message);
    }
    console.log(jsonBody);
  };

  const handleCancelRide = async (id) => {
    console.log("Canceling trip for user ID:", id);
    const user = users.find((u) => u.id === id);

    if (!user?.tripData) {
      console.error("No active trip found");
      return;
    }

    try {
      await cancelRiderTrip(
        user.tripData.trip_id,
        user.id,
        user.tripData.driver_cabId,
        "Cancelled from dashboard",
      );

      setUsers((prev) =>
        prev.map((u) =>
          u.id === id
            ? {
                ...u,
                tripData: null,
                state: "Idle",
              }
            : u,
        ),
      );
    } catch (err) {
      console.error(err);
    }
  };

  const cancelRiderTrip = async (tripId, userId, cabId, reason) => {
    try {
      console.log("Cancelling trip with details:", {
        tripId,
        userId,
        cabId,
        reason,
      });
      const res = await axios.post(
        `${MY_URL}/user/cancelRiderTrip`,
        {
          trip_id: tripId,
          cancelled_by: "Rider",
          completion_status: "cancelled",
          user_id: userId,
          cab_id: cabId,
          tripcancelReason: reason,
        },
        {
          timeout: 5000,
        },
      );

      console.log("Trip cancelled:", res.data);
      return res.data;
    } catch (err) {
      console.error(err.response?.data || err.message);
      throw err;
    }
  };

  const updateRiderDestination = async (
    tripId,
    userId,
    address,
    latitude,
    longitude,
  ) => {
    try {
      const res = await axios.post(
        `${MY_URL}/user/updateRiderDestination`,
        {
          destination: {
            formatted_address: address,
            latitude,
            longitude,
          },
          trip_id: tripId,
          user_id: userId,
        },
        {
          timeout: 5000,
        },
      );

      console.log("Destination updated:", res.data);
      return res.data;
    } catch (err) {
      console.error(err.response?.data || err.message);
      throw err;
    }
  };

  const handleComplete = (id) => {
    setUsers(
      users.map((u) =>
        u.id === id ? { ...u, state: "Idle", message: "" } : u,
      ),
    );
  };

  const handleCancel = (id) => {
    setUsers(
      users.map((u) =>
        u.id === id ? { ...u, state: "Idle", message: "Ride Cancelled" } : u,
      ),
    );
  };

  const getTripDetails = async (trip_id, id) => {
    console.log("Fetching trip details for trip_id:", trip_id, id);
    const result = await axios.post(
      `${MY_URL}/user/getTripDetails`,
      {
        trip_id,
      },
      // {
      //   // headers: {
      //   //   "test-key": "abc123",
      //   //   "test-user-id": id,
      //   // },
      //   timeout: 5000,
      // },
    );
    console.log("Trip Details Response:", result.data);
    users.map((u) => {
      console.log(`${u.id}`, u.tripData);
    });

    setUsers(
      users.map((u) => (u.id === id ? { ...u, tripData: result.data } : u)),
    );
  };

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  function DestinationPicker({ onConfirm, onClose }) {
    const [selectedLocation, setSelectedLocation] = useState(null);

    const handleMapClick = (e) => {
      setSelectedLocation({
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
      });
    };

    return (
      <div className="modal">
        <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
          <GoogleMap
            mapContainerStyle={{
              width: "100%",
              height: "500px",
            }}
            center={{ lat: 25.7048, lng: 94.1063 }}
            zoom={14}
            onClick={handleMapClick}
          >
            {selectedLocation && <Marker position={selectedLocation} />}
          </GoogleMap>
        </LoadScript>

        <button
          disabled={!selectedLocation}
          onClick={() => onConfirm(selectedLocation)}
        >
          Confirm Destination
        </button>

        <button onClick={onClose}>Cancel</button>
      </div>
    );
  }

  return (
    <div className="App">
      User Emulation App {window.authToken}
      {users.length > 0 && (
        <div className="container">
          {users.map((user) => (
            <div key={user.id} className="user-card">
              <div
                style={{
                  border: "1px solid black",
                  margin: "10px",
                  padding: "10px",
                  width: "200px",
                }}
              >
                <h3>{user.name}</h3>
                <p>Role: {user.role}</p>
              </div>
              <select
                value={user.medium || ""}
                onChange={(e) => {
                  setUsers((prevUsers) =>
                    prevUsers.map((u) =>
                      u.id === user.id ? { ...u, medium: e.target.value } : u,
                    ),
                  );
                }}
              >
                <option value="">Select Vehicle</option>
                <option value="Ura Car">Ura Car</option>
                <option value="Ura Premium">Ura Premium</option>
              </select>
              <p>Message:<div className="message-data">{user.message}</div></p>
              <div>
                {user.tripData && (
                  <>
                    <div>OTP : {user.tripData.otp}</div>
                    <br></br>
                    driver details :<div>trip_id :{user.tripData.trip_id}</div>
                    <div>Name :{user.tripData.driver_name}</div>
                    <div>State :{user.tripData.trip_state}</div>
                    <div>Ratings :{user.tripData.driver_ratings}</div>
                    <div>Cab ID :{user.tripData.driver_cabId}</div>
                    {(!user.tripData?.driver_cabColor?.trim() ||
                      user.tripData?.driver_cabColor?.trim() === "N/A") && (
                      <div>{user.tripData.driver_cabColor}</div>
                    )}
                    <div>car type :{user.tripData.vehicle_type}</div>
                    {["PICKUP", "REACHED"].includes(
                      user.tripData.trip_state,
                    ) && (
                      <div>
                        <button onClick={() => handleCancelRide(user.id)}>
                          Cancel Ride
                        </button>
                      </div>
                    )}
                    {["DROPPING"].includes(user.tripData.trip_state) && (
                      <div>
                        <button
                          onClick={() => {
                            setSelectedUser(user);
                            setShowDestinationPicker(true);
                          }}
                        >
                          Update Destination
                        </button>
                      </div>
                    )}
                  </>
                )}
                <div
                  style={{
                    color: user.state === "Searching" ? "orange" : "black",
                  }}
                >
                  {user.tripData ? "In trip" : `${user.state}`}
                </div>

                {user.message != "Completed" ? (
                  <div>
                    {user.state === "Searching" ? (
                      <button onClick={() => handleCancel(user.id)}>
                        Cancel
                      </button>
                    ) : (
                      <button onClick={() => handleSearch(user.id)}>
                        Search
                      </button>
                    )}
                  </div>
                ) : (
                  <button onClick={() => handleComplete(user.id)}>
                    Go Idle
                  </button>
                )}

                {user?.tripData?.trip_state === "PAYMENT" && (
                  <div>{JSON.stringify(user?.tripData?.trip_state)}</div>
                )}
              </div>
            </div>
          ))}

          {showDestinationPicker && (
            <DestinationPicker
              onClose={() => setShowDestinationPicker(false)}
              onConfirm={async (location) => {
                await updateRiderDestination(
                  selectedUser.tripData.trip_id,
                  selectedUser.id,
                  "Updated Destination",
                  location.lat,
                  location.lng,
                );
                setShowDestinationPicker(false);
              }}
            />
          )}
        </div>
      )}
      {/* <div style={{width:'100%',height:'600px',display:'flex',flexDirection:'row'}}>
        <MapPicker onSelect={handleRoute} />
        <FareDetails data={price} />
      </div> */}
      <div>
        <button
          onClick={() => {
            const sendVerificationNotification = async () => {
              try {
                const res = await axios.post(`${MY_URL}/notification/admin/document/notify`, {
                  driver_id: 'URA251015111434',
                  category: "document",
                  title: "Verification Approved",
                  body: "Your documents have been verified successfully.",
                  screen: "Documents",
                });
                

                console.log(res.data);
              } catch (err) {
                console.error(err.response?.data || err.message);
              }

            };
            sendVerificationNotification()
          }}
        >
          send test notification
        </button>

        <button
          onClick={() => {
            const sendNormalNotification = async () => {
              try {
                const res = await axios.post(`${MY_URL}/notification/admin/document/notify`, {
                  driver_id: 'URA251015111434',
                  category: "ride",
                  title: "Test Notification",
                  body: "This is a test notification.",
                  screen: "Notification",
                });
               

                console.log(res.data);
              } catch (err) {
                console.error(err.response?.data || err.message);
              }
            };
             sendNormalNotification()
          }}
        >
          send test notification
        </button>

        <div></div>
        {outStat && (
          <div style={{ marginTop: "20px", fontSize: "18px", color: "blue" }}>
            {outStat}
          </div>
        )}
        <button onClick={sendDummyTrip}>Send Dummy Trip Data</button>
      </div>
      <div>
        {accepts.length > 0 &&
          accepts.map((item) => {
            return (
              <div>
                <div>{JSON.stringify(item)}</div>
                <button
                  onClick={() => {
                    confirmBook(item);
                  }}
                >
                  Confirm booking
                </button>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default App;














// import React, { useEffect, useState } from "react";

// const WS_URL = "wss://ministraple.com"; // your WebSocket URL

// function App() {
//   const [socketConnected, setSocketConnected] = useState(false);
//   const [messages, setMessages] = useState([]);

//   useEffect(() => {
//     // Create WebSocket connection
//     const socket = new WebSocket(WS_URL);

//     // When connection opens
//     socket.onopen = () => {
//       console.log("WebSocket connected!");
//       setSocketConnected(true);

//       // Example: send initial message to server
//       socket.send(JSON.stringify({ type: "init", userId: "72e2f0d5-b1a7-4e20-a935-bcae7f4eb3df" }));
//     };

//     // Listen for messages
//     socket.onmessage = (event) => {
//       console.log("Message from server:", event.data);
//       setMessages((prev) => [...prev, event.data]);
//     };

//     // When connection closes
//     socket.onclose = () => {
//       console.log("WebSocket disconnected");
//       setSocketConnected(false);
//     };

//     // Handle errors
//     socket.onerror = (error) => {
//       console.error("WebSocket error:", error);
//     };

//     // Cleanup on unmount
//     return () => {
//       socket.close();
//     };
//   }, []);

//   return (
//     <div>
//       <h1>WebSocket React Example</h1>
//       <p>Connected: {socketConnected ? "Yes" : "No"}</p>
//       <h2>Messages:</h2>
//       <ul>
//         {messages.map((msg, i) => (
//           <li key={i}>{msg}</li>
//         ))}
//       </ul>
//     </div>
//   );
// }

// export default App;

// import React, { useState } from "react";
// import axios from "axios";
// import {
//   GoogleMap,
//   LoadScript,
//   Marker,
//   Autocomplete,
//   DirectionsRenderer,
// } from "@react-google-maps/api";

// const BASE_URL = "http://192.168.1.100:5000";

// const containerStyle = { width: "100%", height: "400px" };
// const center = { lat: 28.6139, lng: 77.209 };

// function App() {
//   const [pickup, setPickup] = useState(null);
//   const [destination, setDestination] = useState(null);
//   const [fromDistrict, setFromDistrict] = useState("");
//   const [toDistrict, setToDistrict] = useState("");
//   const [directions, setDirections] = useState(null);
//   const [drivers, setDrivers] = useState([]);

//   const [pickupAuto, setPickupAuto] = useState(null);
//   const [destAuto, setDestAuto] = useState(null);

//   // Booking modal state
//   const [selectedDriver, setSelectedDriver] = useState(null);
//   const [tripType, setTripType] = useState("one_way");
//   // const [departureDate, setDepartureDate] = useState("");
//   const [departureDate, setDepartureDate] = useState(
//     new Date().toISOString().slice(0, 16),
//   );

//   const [returnDate, setReturnDate] = useState("");
//   const [userNotes, setUserNotes] = useState("");

//   const [bookingResult, setBookingResult] = useState(null);
//   const [bookingError, setBookingError] = useState("");
//   const [loading, setLoading] = useState(false);

//   // ── Extract district/city name from Google place ──
//   const getDistrict = (place) => {
//     const component = place.address_components?.find(
//       (c) =>
//         c.types.includes("administrative_area_level_3") ||
//         c.types.includes("locality"),
//     );
//     return component?.long_name || place.name || "";
//   };

//   const handlePickupPlace = () => {
//     const place = pickupAuto.getPlace();
//     const location = place.geometry.location;
//     setPickup({ lat: location.lat(), lng: location.lng() });
//     setFromDistrict(getDistrict(place));
//   };

//   const handleDestPlace = () => {
//     const place = destAuto.getPlace();
//     const location = place.geometry.location;
//     setDestination({ lat: location.lat(), lng: location.lng() });
//     setToDistrict(getDistrict(place));
//   };

//   const getRoute = () => {
//     if (!pickup || !destination) return;
//     const directionsService = new window.google.maps.DirectionsService();
//     directionsService.route(
//       {
//         origin: pickup,
//         destination: destination,
//         travelMode: window.google.maps.TravelMode.DRIVING,
//       },
//       (result, status) => {
//         if (status === "OK") setDirections(result);
//       },
//     );
//   };

//   const searchDrivers = async () => {
//     try {
//       console.log(pickup,destination)
//       const res = await axios.post(
//         `${BASE_URL}/outstation/user/route/search`,
//         {
//           pickup_coordinates: { lat: pickup.lat, lng: pickup.lng },
//           destination_coordinates: {
//             lat: destination.lat,
//             lng: destination.lng,
//           },
//         },
//       );
//       console.log("Available Drivers:", res.data);
//       setDrivers(res.data.data || []);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const openBookingForm = (driver) => {
//     setSelectedDriver(driver);
//     setBookingResult(null);
//     setBookingError("");
//     setDepartureDate("");
//     setReturnDate("");
//     setUserNotes("");
//     setTripType("one_way");
//   };

//   // ── Calls POST /outstation/routes/user/book ──
//   const confirmBooking = async () => {
//     console.log(departureDate);
//     // if (!departureDate) {
//     //   setBookingError("Please select a departure date.");
//     //   return;
//     // }
//     if (tripType === "round_trip" && !returnDate) {
//       setBookingError("Please select a return date for round trip.");
//       return;
//     }

//     setLoading(true);
//     setBookingError("");

//     const getLocalDateTime = () => {
//       const now = new Date();
//       const offset = now.getTimezoneOffset() * 60000;
//       const local = new Date(now - offset);
//       return local.toISOString().slice(0, 16);
//     };

//     try {
//       const payload = {
//         user_id: "72e2f0d5-b1a7-4e20-a935-bcae7f4eb3df",
//         assigned_driver_id: selectedDriver.driver_id,
//         price: selectedDriver.price,
//         pickup_coordinates: pickup,
//         destination_coordinates: destination,
//         from_district: fromDistrict,
//         to_district: toDistrict,
//         trip_type: tripType,
//         trip_departure_date: getLocalDateTime(),
//         trip_return_date: tripType === "round_trip" ? returnDate : null,
//         user_notes: userNotes || null,
//       };

//       console.log("Booking Payload:", payload);

//       console.log("Booking Payload:", payload);

//       const res = await axios.post(
//         `${BASE_URL}/outstation/user/booking/book`,
//         payload,
//       );

//       setBookingResult(res.data.data);
//       setSelectedDriver(null);
//     } catch (err) {
//       const msg =
//         err.response?.data?.error ||
//         err.response?.data?.errors?.join(", ") ||
//         "Booking failed. Please try again.";
//       setBookingError(msg);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <LoadScript
//       googleMapsApiKey="AIzaSyDJWb2g6bYlGDSFG4r7YaF9VxGmBVIRvyk"
//       libraries={["places"]}
//     >
//       <div style={{ padding: "20px" }}>
//         <h2>Outstation Booking</h2>

//         <div style={{ marginBottom: "10px" }}>
//           <Autocomplete
//             onLoad={setPickupAuto}
//             onPlaceChanged={handlePickupPlace}
//           >
//             <input placeholder="Pickup location" style={inputStyle} />
//           </Autocomplete>

//           <Autocomplete onLoad={setDestAuto} onPlaceChanged={handleDestPlace}>
//             <input placeholder="Destination" style={inputStyle} />
//           </Autocomplete>

//           <button onClick={getRoute} style={btnStyle}>
//             Show Route
//           </button>
//           <button onClick={searchDrivers} style={btnStyle}>
//             Search Drivers
//           </button>
//         </div>

//         <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={6}>
//           {pickup && <Marker position={pickup} />}
//           {destination && <Marker position={destination} />}
//           {directions && <DirectionsRenderer directions={directions} />}
//         </GoogleMap>

//         {bookingResult && (
//           <div style={successBanner}>
//             ✅ Booking Confirmed! ID:{" "}
//             <strong>{bookingResult.outstation_bookings_id}</strong>
//             <br />
//             Driver: {bookingResult.assigned_driver_id} | ₹{bookingResult.price}{" "}
//             | {bookingResult.trip_type}
//           </div>
//         )}

//         <h3>Available Drivers</h3>
//         {drivers.map((d, i) => (
//           <div key={i} style={card}>
//             <span>
//               {d.driver_name} — ₹{d.price}
//             </span>
//             <button style={btnStyle} onClick={() => openBookingForm(d)}>
//               Book
//             </button>
//           </div>
//         ))}

//         {selectedDriver && (
//           <div style={overlay}>
//             <div style={modal}>
//               <h3>Book {selectedDriver.driver_name}</h3>
//               <p style={{ color: "#555" }}>
//                 ₹{selectedDriver.price} &nbsp;|&nbsp; {fromDistrict} →{" "}
//                 {toDistrict}
//               </p>

//               <label style={labelStyle}>Trip Type</label>
//               <select
//                 value={tripType}
//                 onChange={(e) => setTripType(e.target.value)}
//                 style={inputStyle}
//               >
//                 <option value="one_way">One Way</option>
//                 <option value="round_trip">Round Trip</option>
//               </select>

//               <label style={labelStyle}>Departure Date & Time</label>
//               <input
//                 type="datetime-local"
//                 value={departureDate}
//                 onChange={(e) => setDepartureDate(e.target.value)}
//                 style={inputStyle}
//               />

//               {tripType === "round_trip" && (
//                 <>
//                   <label style={labelStyle}>Return Date & Time</label>
//                   <input
//                     type="datetime-local"
//                     value={returnDate}
//                     onChange={(e) => setReturnDate(e.target.value)}
//                     style={inputStyle}
//                   />
//                 </>
//               )}

//               <label style={labelStyle}>Notes (optional)</label>
//               <input
//                 type="text"
//                 placeholder="Any special requests..."
//                 value={userNotes}
//                 onChange={(e) => setUserNotes(e.target.value)}
//                 style={inputStyle}
//               />

//               {bookingError && (
//                 <p style={{ color: "red", marginTop: "8px" }}>{bookingError}</p>
//               )}

//               <div style={{ marginTop: "15px" }}>
//                 <button
//                   onClick={confirmBooking}
//                   style={{
//                     ...btnStyle,
//                     background: loading ? "#999" : "#28a745",
//                   }}
//                   disabled={loading}
//                 >
//                   {loading ? "Booking..." : "Confirm Booking"}
//                 </button>
//                 <button
//                   onClick={() => setSelectedDriver(null)}
//                   style={{ ...btnStyle, background: "#dc3545" }}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </LoadScript>
//   );
// }

// export default App;

// // ── Styles ──────────────────────────────────────
// const inputStyle = {
//   width: "300px",
//   padding: "10px",
//   margin: "5px",
//   display: "block",
// };

// const btnStyle = {
//   padding: "10px",
//   margin: "5px",
//   background: "#007bff",
//   color: "#fff",
//   border: "none",
//   cursor: "pointer",
//   borderRadius: "4px",
// };

// const card = {
//   padding: "10px",
//   background: "#f1f1f1",
//   margin: "10px 0",
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
// };

// const successBanner = {
//   background: "#d4edda",
//   border: "1px solid #c3e6cb",
//   padding: "12px 16px",
//   margin: "15px 0",
//   borderRadius: "6px",
//   color: "#155724",
// };

// const overlay = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   width: "100vw",
//   height: "100vh",
//   background: "rgba(0,0,0,0.5)",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   zIndex: 1000,
// };

// const modal = {
//   background: "#fff",
//   padding: "30px",
//   borderRadius: "10px",
//   width: "400px",
//   boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
// };

// const labelStyle = {
//   display: "block",
//   marginTop: "12px",
//   fontWeight: "600",
//   fontSize: "13px",
// };
